import React from "react";
import { Box, Card, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { formatTrafficBytes, formatMostApChannel } from "../helper";

const SummaryCard = ({ title, value, subtext }) => {
  const theme = useTheme();
  return (
    <Card
      sx={{
        flex: 1,
        minWidth: "160px",
        p: 2,
        borderRadius: "8px",
        boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.05)",
        border: "1px solid #e0e4f0",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        bgcolor: "#fff",
      }}
    >
      <Typography
        sx={{
          fontSize: theme.typography.customFontSize[0],
          color: theme.palette.primary.greyPrimary,
          fontWeight: theme.typography.customFontWeight[1],
          mb: 1.5,
          letterSpacing: "0.5px",
        }}
      >
        {title}
      </Typography>
      <Box sx={{ display: "flex", alignItems: "baseline", gap: 1 }}>
        <Typography
          sx={{
            fontSize: "24px",
            color: "#172264",
            fontWeight: "bold",
          }}
        >
          {value}
        </Typography>
        {subtext && (
          <Typography
            sx={{
              fontSize: theme.typography.customFontSize[1],
              color: theme.palette.primary.greyThird,
              fontWeight: theme.typography.customFontWeight[1],
            }}
          >
            {subtext}
          </Typography>
        )}
      </Box>
    </Card>
  );
};

const Summary = ({ SummaryData = {} }) => {
  const {
    switchOnline = 0,
    switchTotal = 0,
    apOnline = 0,
    apTotal = 0,
    clientsOnlineLast = 0,
    clientsNew = 0,
    wirelessTotalTrafficBytes = 0,
    poeBudgetPercent = null,
    poeCapacityW = 0,
    mostApChannel = null,
  } = SummaryData;

  const mostApChannelText = formatMostApChannel(mostApChannel);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
        gap: 3,
        width: "100%",
      }}
    >
      <SummaryCard
        title="Switch Online / Total"
        value={`${switchOnline} / ${switchTotal}`}
      />
      <SummaryCard
        title="AP Online / Total"
        value={`${apOnline} / ${apTotal}`}
      />
      <SummaryCard
        title="Clients Online (last)"
        value={clientsOnlineLast}
        subtext={`/ New: ${clientsNew}`}
      />
      <SummaryCard
        title="Wireless Total Traffic (GB)"
        value={formatTrafficBytes(wirelessTotalTrafficBytes)}
      />
      <SummaryCard
        title="PoE Budget"
        value={poeBudgetPercent !== null ? `${poeBudgetPercent.toFixed(2)}%` : "-"}
        subtext={`Capacity: ${poeCapacityW.toLocaleString()} W`}
      />
      <SummaryCard
        title="Most AP Channel"
        value={mostApChannelText}
      />
    </Box>
  );
};

export default Summary;
